import { render, staticRenderFns } from "./Fifty_percent.vue?vue&type=template&id=47a8bc1e&scoped=true"
import script from "./Fifty_percent.vue?vue&type=script&lang=js"
export * from "./Fifty_percent.vue?vue&type=script&lang=js"
import style0 from "./Fifty_percent.vue?vue&type=style&index=0&id=47a8bc1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a8bc1e",
  null
  
)

export default component.exports